module.exports = "<h2 class=\"page_tit\">\r\n  조직관리<span>- MDM사용자의 조직 및 부서를 관리합니다.</span>\r\n</h2>\r\n"


//////////////////
// WEBPACK FOOTER
// C:/Users/sung/WebstormProjects/exafe front/src/app/page/system/dept_management.html
// module id = ../../../../../src/app/page/system/dept_management.html
// module chunks = 1